import style from './../flag.module.css'

interface Props {
    countryCode: string
}

const Flag = ({ countryCode }: Props) => {
    const lowerCountryCode = countryCode.toLowerCase()

    return (
        <span
            className={[
                style['iti-flag'],
                style[lowerCountryCode],
                lowerCountryCode === 'gb' ? style.gbNormalized : '',
            ].join(' ')}
        />
    )
}

export default Flag
